import defaultHeaders from "../headers"
import client from "../memberService/client"
import {Response} from "../Model"
import {UserMembershipResponse} from "./oaMembership"

interface MembershipDraftRequest {
    nric: string,
    dob: string,
}

interface ApplicationError {
    error: string,
    errorDescription: string,
    errorCode: ErrorCode
}

enum ErrorCode {
    RECORD_NOT_FOUND = `RECORD_NOT_FOUND`,
    UNKNOWN_ERROR = `UNKNOWN_ERROR`,
    UNAUTHENTICATED = `UNAUTHENTICATED`,
    VALIDATION_ERROR = `VALIDATION_ERROR`,
    MULTIPLE_DEVICE_FOUND_ERROR = `MULTIPLE_DEVICE_FOUND_ERROR`,
    DB_ERROR = `DB_ERROR`,
    SIGNUP_FEE_NOT_CONFIGURED = `SIGNUP_FEE_NOT_CONFIGURED`,
    RENEW_FEE_NOT_CONFIGURED = `RENEW_FEE_NOT_CONFIGURED`,
    UCEM_MEMBERSHIP_EXISTS = `UCEM_MEMBERSHIP_EXISTS`,
    RECORD_EXISTS_ACTIVE = `RECORD_EXISTS_ACTIVE`,
    RECORD_EXISTS_DRAFT = `RECORD_EXISTS_DRAFT`,
    OTP_VERIFICATION_FAILED = `OTP_VERIFICATION_FAILED`,
    BATCH_SIZE_EXCEEDED = `BATCH_SIZE_EXCEEDED`,
    ACTIVE_MEMBERSHIP_EXIST = `ACTIVE_MEMBERSHIP_EXIST`,
    CANNOT_PROCEED = `CANNOT_PROCEED`,
    LINKPASS_USER_EXISTS = `LINKPASS_USER_EXISTS`,
    EMAIL_UNAVAILABLE = `EMAIL_UNAVAILABLE`,
    NRIC_UNAVAILABLE = `NRIC_UNAVAILABLE`,
    OTP_EXCEED_TIMES = `OTP_EXCEED_TIMES`,
    MEMBERSHIP_CONNECTION_FAIL = `MEMBERSHIP_CONNECTION_FAIL`,
}

// Retrieves a draft by last four digits of NRIC and Date of Birth
const postMembershipDraft = (payload: MembershipDraftRequest) => {
    return client.post<Response<UserMembershipResponse>>(
        `membership/draft`,
        payload,
    )
}

// logged in version
const postMembershipDraftMembership = (payload: MembershipDraftRequest) => {
    return client.post<Response<UserMembershipResponse>>(
        `membership/draftMembership`,
        payload,
        {
            headers: defaultHeaders(),
        },
    )
}

export {postMembershipDraft, postMembershipDraftMembership}
export type {ApplicationError, MembershipDraftRequest}
